var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMUpdates = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.36 10.64v9.03H4.48V5.35h7.95c.06-.59.22-1.16.47-1.67H4.02c-.66 0-1.21.54-1.21 1.21v15.24c0 .66.54 1.21 1.21 1.21h12.81c.66 0 1.21-.54 1.21-1.21v-9.46c-.24.04-.48.05-.72.05-.32 0-.64-.03-.95-.09Zm-9.55 4.72c-.46 0-.83.37-.83.83s.37.83.83.83h7.22c.46 0 .83-.37.83-.83s-.37-.83-.83-.83zm.01-3.7h7.22c.46 0 .83.37.83.83s-.37.83-.83.83H6.82c-.46 0-.83-.37-.83-.83s.37-.83.83-.83M12.84 8H6.81c-.46 0-.83.37-.83.83s.37.83.83.83h7.35c-.55-.45-1-1.02-1.31-1.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed1c24",
    fillRule: "evenodd",
    d: "M17.31 1.96c-2.13 0-3.86 1.73-3.86 3.86s1.73 3.87 3.86 3.87 3.87-1.73 3.87-3.87-1.74-3.86-3.87-3.86m.76 6.19c0 .21-.16.37-.37.37h-.57c-.21 0-.37-.16-.37-.37V5.43c0-.21.16-.37.37-.37h.57c.21 0 .37.16.37.37zm-.65-3.63c-.39 0-.7-.31-.7-.7s.31-.7.7-.7.69.32.69.7-.31.7-.69.7"
  })));
};
export default SvgMUpdates;